export default {
    tokenKey: 'fqpEL13Cm60mW1Vt',
    ivKey: 'uvSSRQrVVfFCvtZR',
    tokenExpires: 2,
}
